import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  const location = useLocation();

  return (
    <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-1 text-xs flex-wrap">
        <li>
          <Link to="/" className="text-[#525252] hover:text-[#F7931E] transition-colors flex items-center gap-1">
            <Home size={12} /> Home
          </Link>
        </li>
        {items.map((item, i) => (
          <li key={item.label} className="flex items-center gap-1">
            <ChevronRight size={12} className="text-[#363636]" />
            {item.href && i < items.length - 1 ? (
              <Link to={item.href} className="text-[#525252] hover:text-[#F7931E] transition-colors">{item.label}</Link>
            ) : (
              <span className="text-[#A3A3A3]">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
